// hacksaw
import { responseService } from '@aceroll/platform-hacksaw';

// controllers
import { EvFeatureExit } from '../controllers/ev-feature-exit';
import { EvFsRespin } from '../controllers/ev-fs-respin';
import { EvMaxWin } from '../controllers/ev-max-win';

export function evFsRespinDecision() {
	const event = responseService.getEvent();
	switch (event.type) {
		case 'fs_respin':
			return EvFsRespin;
		case 'feature_exit':
			return EvFeatureExit;
		case 'max_win_reached':
			return EvMaxWin;
		default:
			throw new Error('Event is not provided');
	}
}
